import React from 'react';
import ReactEcharts from 'echarts-for-react';
import appconstant from '../../../themes/appconstant';
import { useSelector } from 'react-redux';

const SignChart = () => {
  const singUpsData = useSelector((state) => state.dashboardReducer);
  const totalUser = singUpsData.totalUser;

  const malePercentage = totalUser ? ((singUpsData.male / totalUser) * 100).toFixed(0) : 0;
  const femalePercentage = totalUser ? ((singUpsData.female / totalUser) * 100).toFixed(0) : 0;


  const option = {
    tooltip: {
      trigger: 'item',
      formatter: function (params) {
        if (params.seriesName === 'Access From') {

          const customValue = params.name === 'Male' ? singUpsData.male : singUpsData.female;
          return ` ${customValue}`;
        }
        return params.value;
      }
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'inside',
          formatter: '{c}%',
          color: 'white',
        },
        labelLine: {
          show: false
        },
        data: [
          { value: malePercentage, name: 'Male' },
          { value: femalePercentage, name: 'Female' }
        ],
        color: ["#7C63A4", "#F16480"]
      }
    ],
    graphic: [
      {
        type: 'text',
        left: 'center',
        top: 'middle',
        style: {
          text: singUpsData.totalUser,
          textAlign: 'center',
          fill: '#2F2F2F',
          fontSize: 20,
          fontWeight: 600
        }
      },
      {
        type: 'text',
        left: 'center',
        top: '55%',
        style: {
          text: 'Total',
          textAlign: 'center',
          fill: 'rgba(47, 47, 47, 0.4)',
          fontSize: 12
        },


      }
    ]
  };

  return (
    <div>
      <div className='flex justify-between items-center'>
        <div className='flex flex-col gap-2 pt-[100px] ml-8'>
          <div className='text-xl font-semibold text-dark '>{appconstant.gender}</div>
          <div className='flex items-center gap-2'>
            <div className='w-[10px] h-[10px] bg-purple rounded-full'> </div>
            <div className='text-base text-gray60 font-normal '>{appconstant.male}</div>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-[10px] h-[10px] bg-pink rounded-full'> </div>
            <div className='text-base text-gray60 font-normal '>{appconstant.feMale}</div>
          </div>
        </div>
        <ReactEcharts
          option={option}
          opts={{ renderer: 'svg' }}
          style={{ width: "250px", height: "250px" }}
        />
      </div>
    </div>
  );
};

export default SignChart;